<template>
  <Button :variant="'pill-button'" class="full-details-btn small-margin-left-xxs medium-margin-left-xs" :class="{ hide }" @click="$emit('click')">
    <span class="heavy">{{ text }}</span>
  </Button>
</template>

<script setup>
import Button from '@atomic-ui/button/Button';

defineProps({
  text: {
    type: String,
    required: true,
  },
  hide: {
    type: Boolean,
    default: false,
  },
});

defineEmits(['click']);
</script>

<style lang="scss" scoped brand="mcom">
@import '~settingSCSS';

.full-details-btn {
  height: 36px;
  border-radius: 50px;
}
</style>
